<template>
  <v-container fluid grid-list-xl page>
    <v-layout row wrap>
      <v-flex xs12 sm8 md12>
        <section-header v-text="page.headline"></section-header>
        <div class="subheading justify" v-html="page.description"></div>
        <div class="my-5"></div>
      </v-flex>
    </v-layout>
    <!-- Your contet -->

    <div class="display-2 grey--text text--darken-1">
      Identifica personas con sus documentos de identidad
    </div>
    <div class="title grey--text text--darken-1">
      desde cualquier dispositivo sin tener que instalar ninguna aplicación
    </div>

    <v-layout>
      <v-flex>
        <v-card class="justify-center">
          <v-container fluid grid-list-md>
            <v-layout row wrap class="justify-center">
              <v-flex xs12 md6 lg3 offset-2>
                <v-card flat tile>
                  <v-img
                    justify-center
                    src="/static/send.png"
                    width="100"
                    aspect-ratio="1"
                  ></v-img>

                  <v-card-title primary-title>
                    <div>
                      <h3 class="headline mb-0">ENVIA</h3>
                      <div>
                        Inicia una identificación desde tu navegador, se
                        generará un email o un enlace que llegará a la persona
                        que quieres identificar.
                      </div>
                    </div>
                  </v-card-title>

                  <!-- <v-card-actions>
                    <v-btn flat color="orange">Share</v-btn>
                    <v-btn flat color="orange">Learn More</v-btn>
                  </v-card-actions> -->
                </v-card>
              </v-flex>

              <!-- --------- -->

              <v-flex xs12 md6 lg3>
                <v-card flat tile>
                  <v-img
                    src="/static/digital-signature.png"
                    width="100"
                    aspect-ratio="1"
                  ></v-img>

                  <v-card-title primary-title xs12 sm3>
                    <div>
                      <h3 class="headline mb-0">EJECUTA</h3>
                      <div>
                        La persona que tiene quee identificarse recibirá un
                        email para comenzar el proceso de identificación. Lo
                        podrá realizar desde su PC o teléfono móvil. No necesita
                        nada más que su cara y su documento de identidad
                      </div>
                    </div>
                  </v-card-title>

                  <!-- <v-card-actions>
                    <v-btn flat color="orange">Learn More</v-btn>
                  </v-card-actions> -->
                </v-card>
              </v-flex>

              <v-flex xs12 md6 lg3>
                <v-card flat tile>
                  <v-img
                    s
                    src="/static/admin.png"
                    width="100"
                    aspect-ratio="1"
                  ></v-img>

                  <v-card-title primary-title xs12 sm3>
                    <div>
                      <h3 class="headline mb-0">GESTIONA</h3>
                      <div>
                        Revisa las imágenes capturadas y el video grabado de la
                        cara y el documento de identidad así como el texto
                        eextraido por OCR. Puedes acceder a los resultados de
                        las identificaciones de forma rápida y sencilla.
                      </div>
                    </div>
                  </v-card-title>

                  <!-- <v-card-actions>
                    <v-btn flat color="orange">Share</v-btn>
                    <v-btn flat color="orange">Learn More</v-btn>
                  </v-card-actions> -->
                </v-card>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card>
      </v-flex>
    </v-layout>
    <v-spacer></v-spacer>
  

    <v-layout height="100">
      <v-card height="100" flat color="grey"> </v-card>
    </v-layout>

    <div class="display-2 black--text text--darken-3 justify-center">
      Identificaciones no presenciales
    </div>
    <div class="title black--text text--darken-1">
      desde cualquier dispositivo, sin necesiidad de instalar apliicaciones
    </div>

    <v-dialog v-model="isCreateSign" persistent max-width="500px">
      <v-card>
        <v-toolbar color="orange" dark>
          <!-- <v-toolbar-side-icon></v-toolbar-side-icon> -->
          <v-toolbar-title>Nueva Video-Identificación </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-tooltip right>
            <v-icon slot="activator" color="white" dark>help_outline</v-icon>
            <span
              ><b>
                Verificación de identidad : <br /><br />- Identifica por video
                de forma remota y automática </b
              ><br /><br />
            </span>
          </v-tooltip>
        </v-toolbar>
        <create-sign-video-page
          :scroll-top="scrollTop"
          signature-type="video"
        ></create-sign-video-page>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            flat
            round
            color="orange darken-4"
            dark
            bold
            outline
            @click.native="closeSignaturePage"
            >Cerrar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="isLoginNeeded" max-width="300px">
      <v-card>
        <v-toolbar color="orange" dark>
          <v-toolbar-title>Es necesario estar registrado</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap></v-layout>
            <span
              >Por favor entra en tu cuenta o regístrate para usar este servicio
            </span>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            flat
            round
            color="orange darken-4"
            dark
            bold
            outline
            @click.native="isLoginNeeded = false"
            >Cerrar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import CreateSignVideoPage from "./CreateSignVideoPage";

export default {
  components: {
    CreateSignVideoPage
  },
  beforeCreate() {
    window.scrollTo(0, 0);
  },
  // mounted() {
  //   // Google Analytics
  //   this.$ga.page(this.$router);
  // },
  data() {
    return {
      isLoginNeeded: false,
      isCreateSign: false,
      page: {
        title: "Video Identificación ",
        headline: "Video Identificación",
        description: `Automatiza la identificación de personas`
      },
      breadcrumbs: [
        {
          text: "Src",
          disabled: false
        },
        {
          text: "Views",
          disabled: false
        },
        {
          text: "Blank",
          disabled: false
        }
      ],
      scrollTop: 0
    };
  },
  methods: {
    createSignature() {
      //this.$router.push("CreateSignPage")
      var current = this.$store.getters.userData;
      if (current == null || current.userEmail == null) {
        this.isLoginNeeded = true;
        this.$ga.event({
          eventCategory: "Login needed video identification", // str
          eventAction: "click", // str
          eventLabel: "TryButton", // str
          eventValue: 0 // int
        });
        return;
      }
      this.scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      document.getElementsByTagName("body")[0].className = "noscroll";
      this.isCreateSign = true;
    },
    closeSignaturePage() {
      document.body.removeAttribute("class", "noscroll");
      window.scrollTo(0, this.scrollTop);
      this.isCreateSign = false;
    }
  }
};
</script>
